module.exports = __webpack_public_path__ + "static/media/marek_wolfryd_16.076ffa10.jpg";